var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-chip',{staticClass:"py-0 px-1",attrs:{"color":"discount","small":"","text-color":"discount-text","label":""}},[_vm._v(" "+_vm._s(_vm._f("discountPct")(_vm.amount))+"% "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }